import { ComponentType } from 'react';
import { shallowEqual } from 'react-redux';
import { PapiUser } from '@wix/da-papi-types';
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getGruser } from '../selectors';

export type WithGruserProps = {
  gruser?: PapiUser;
};

export const useGruser = (): WithGruserProps => ({
  ...useMMSelector(
    state => ({
      gruser: getGruser(state),
    }),
    shallowEqual
  ),
});

export default <TProps>(
  component: ComponentType<TProps>
): ComponentType<TProps> =>
  connectMediaStore(state => ({
    gruser: getGruser(state),
  }))(component as ComponentType<any>); // redux is a bit dumb with generics
